<div class="edp-card-contract card h-100 justify-content-center">
    <div class="text-center d-flex">
        <span class="card-icon"><i class="icon icon-edponline-Bop-003 disabled" aria-hidden="true"></i></span>
        <span (click)="onRemove($event)" class="card-trash-icon"><i class="icon icon-edponline-Bra-068"></i></span>
    </div>
    <div class="card-status text-center my-lg-4 font-weight-bold">
        <span>{{ "pt.edp.edponline.contract.pending.approval.status" | translate }}</span>
    </div>
    <div class="card-origin text-center">
        <span>
            {{ "pt.edp.edponline.contract.pending.approval.requestedBy" | translate }}
            <span class="font-weight-bold">{{ pendingContract.source }}</span>
            {{ "pt.edp.edponline.contract.pending.approval.recipient" | translate }}
            <span class="font-weight-bold">{{ pendingContract.name }}</span>
        </span>
    </div>
</div>
